import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import { Button, Card, FormRow, Input } from '@/admin-design/_common';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const qc = useQueryClient();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await api.login(email, password);
      qc.setQueryData(['me'], user);
      navigate('/');
    } catch (err: any) {
      setError(err.message || '로그인 실패');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-muted/50">
      <Card className="w-96 shadow-sm">
        <form onSubmit={submit} className="p-8 space-y-4">
          <div>
            <h1 className="text-2xl font-bold">Shopping Sync</h1>
            <p className="text-sm text-muted-foreground">도매처 → 스마트스토어 자동 동기화</p>
          </div>
          <FormRow label="이메일" required stacked>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              required
              autoComplete="email"
            />
          </FormRow>
          <FormRow label="비밀번호" required stacked>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              revealable
            />
          </FormRow>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <Button type="submit" variant="primary" className="w-full" loading={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
